// 淘宝店状态文案与颜色（文档 18 §4 收敛：一行只一个实底标签给订单状态；结算方式用色点）。
import type { TagTone } from '@/lib/status';
import type { TaobaoStatus } from './types';

export const taobaoStatus: Record<TaobaoStatus, { label: string; tone: TagTone }> = {
  DRAFT: { label: '草稿', tone: 'none' },
  COMPLETED: { label: '已出库', tone: 'green' },
  PARTIALLY_RETURNED: { label: '部分退货', tone: 'orange' },
  RETURNED: { label: '已退货', tone: 'red' },
  CANCELLED: { label: '已取消', tone: 'none' },
};

export const settlementType: Record<string, { label: string; dot: 'green' | 'blue' }> = {
  CASH: { label: '现结', dot: 'green' },
  MONTHLY: { label: '月结', dot: 'blue' },
};

export const lineKind = (t: string) => (t === 'BUNDLE' ? '套装' : '单品');
